export const cryptPayoutSystems = ['bitcoin123', 'tether', 'tether_trc20', 'tron', 'bitcoin', 'doge', 'eth', 'ethereum']
